module.exports = __webpack_public_path__ + "img/dsci0031.394b4aa6.jpg";